import { lazy, Suspense } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { SiteShell } from "./components/SiteShell"
import legacyRedirects from "./content/legacy-redirects.json"

const HomePage = lazy(() => import("./pages/HomePage").then((module) => ({ default: module.HomePage })))
const AboutPage = lazy(() => import("./pages/AboutPage").then((module) => ({ default: module.AboutPage })))
const WorkPage = lazy(() => import("./pages/WorkPage").then((module) => ({ default: module.WorkPage })))
const StoriesPage = lazy(() =>
  import("./pages/StoriesPage").then((module) => ({ default: module.StoriesPage })),
)
const ArticlePage = lazy(() =>
  import("./pages/StoriesPage").then((module) => ({ default: module.ArticlePage })),
)
const ContactPage = lazy(() =>
  import("./pages/ContactPage").then((module) => ({ default: module.ContactPage })),
)

export default function App() {
  return (
    <SiteShell>
      <Suspense fallback={<div className="page-loader" aria-label="Loading" />}>
        <Routes>
          <Route element={<HomePage />} path="/" />
          <Route element={<AboutPage />} path="/about" />
          <Route element={<WorkPage />} path="/work" />
          <Route element={<StoriesPage />} path="/stories" />
          <Route element={<ContactPage />} path="/connect" />
          {legacyRedirects.redirects.map(({ from, to }) => (
            <Route element={<Navigate replace to={to} />} key={from} path={from} />
          ))}
          <Route element={<Navigate replace to="/stories" />} path="/biased/tag/*" />
          <Route element={<Navigate replace to="/stories" />} path="/biased/category/*" />
          <Route element={<ArticlePage />} path="/biased/*" />
          <Route element={<Navigate replace to="/" />} path="*" />
        </Routes>
      </Suspense>
    </SiteShell>
  )
}
